module.exports = __webpack_public_path__ + "8723d567.woff2";